import React from 'react';
import { ModalWrapper, ModalBody, ModalFooter, ModalPrimaryButton } from '@zooplus/ui-components';
import { useTranslation } from 'react-i18next';
import { FormConfirmationProps } from './fields/types';

const FormConfirmation: React.FC<FormConfirmationProps> = (props) => {
  const { t } = useTranslation();

  const headerText = t(`form.confirmation.${props.type}.header`);
  const messageText = t(`form.confirmation.${props.type}.message`);
  const confirmationButtonText = t('common.ok');
  const closeButtonText = t('common.close');

  return (
    <div data-test="contactForm.confirmationModal">
      <ModalWrapper
        heading={headerText}
        headingId="contact-form-confirmation-modal"
        closeBtnAriaLabel={closeButtonText}
        isShown={props.isShown}
        onClose={props.onClose}
        className={`confirmationModal confirmationModal__${props.type}`}>
        <ModalBody>{messageText}</ModalBody>
        <ModalFooter>
          <ModalPrimaryButton onClick={props.onConfirm}>
            {confirmationButtonText}
          </ModalPrimaryButton>
        </ModalFooter>
      </ModalWrapper>
    </div>
  );
};

export default FormConfirmation;
